module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.emailData === null) ? _c('form', {
    staticClass: "ui-content edi-mobilecheck",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onMobileSubmit.apply(null, arguments)
      }
    }
  }, [_c('p', {
    staticClass: "notfound fieldset-1"
  }, [_vm._v("抱歉，您尚未绑定邮箱！")]), _vm._v(" "), _c('fieldset', {
    staticClass: "ui-controlgroup"
  }, [_c('input', {
    staticClass: "submit",
    attrs: {
      "type": "button",
      "value": "确定"
    },
    on: {
      "click": _vm.onConfirm
    }
  })]), _vm._v(" "), _c('router-link', {
    staticClass: "bind",
    attrs: {
      "to": "/email-bind"
    }
  }, [_vm._v("立即绑定邮箱")])], 1) : _c('form', {
    staticClass: "ui-content edi-mobilecheck",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onMobileSubmit.apply(null, arguments)
      }
    }
  }, [_c('p', {
    staticClass: "mobile fieldset-1",
    staticStyle: {
      "margin-top": "0 !important"
    }
  }, [_vm._v("\n\t\t\t当前绑定邮箱"), _c('br'), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.hideEmail))]), _c('br'), _vm._v("\n\t\t\t如需解绑，请先验证\n\t\t")]), _vm._v(" "), _c('ul', {
    staticClass: "ui-listview ui-listview-inset"
  }, [_c('li', {
    staticClass: "ui-listview-one-item",
    staticStyle: {
      "display": "flex",
      "border-bottom": "1px solid #ddd"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.verifyCode),
      expression: "verifyCode"
    }],
    attrs: {
      "type": "text",
      "name": "verifyCode",
      "placeholder": "图形验证码"
    },
    domProps: {
      "value": (_vm.verifyCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.verifyCode = $event.target.value
      }
    }
  }), _vm._v(" "), _c('img', {
    staticStyle: {
      "height": "36px"
    },
    attrs: {
      "src": _vm.verifyCodeImg
    },
    on: {
      "click": _vm.refreshVerifyCodeClick
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "ui-listview-one-item"
  }, [_c('div', {
    staticClass: "ui-col-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.code),
      expression: "code"
    }],
    attrs: {
      "type": "text",
      "placeholder": "验证码"
    },
    domProps: {
      "value": (_vm.code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.code = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "ui-col-4 ui-align-right"
  }, [_c('email-code', {
    attrs: {
      "type": 5,
      "email": _vm.emailData,
      "uuid": _vm.verifyUUID,
      "verifyCode": _vm.verifyCode
    }
  })], 1)])]), _vm._v(" "), _c('fieldset', {
    staticClass: "ui-controlgroup"
  }, [_c('input', {
    staticClass: "submit",
    class: {
      'ui-disable': _vm.submitDisable
    },
    attrs: {
      "type": "submit",
      "value": "确定"
    }
  })])]), _vm._v(" "), _c('tips', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tips),
      expression: "tips"
    }],
    attrs: {
      "btnNum": _vm.btnNum,
      "tipsFont": _vm.tipsFont
    },
    on: {
      "tipStatus": _vm.tipStatus
    }
  }), _vm._v(" "), _c('tips-auto', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tipsauto),
      expression: "tipsauto"
    }],
    attrs: {
      "tipsFont": _vm.tipsFont
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-167ca8d7!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Email.vue
// module id = 536
// module chunks = 1